import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import MuiChip from "@material-ui/core/Chip";
import grey from "@material-ui/core/colors/grey";

const useStyles = makeStyles(() => ({
  chip: {
    margin: "3px 4px 4px 0",
    maxWidth: 325,
    background: grey[300],
    color: grey[500],
  },
  label: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    display: "inline-block",
    overflow: "hidden",
    fontWeight: 600,
  },
}));

function Chip(props) {
  const { className, text, cannotDelete = false, onDelete, characterLimit = 100, ...other } = props;
  const classes = useStyles();
  let otherProps;

  if (cannotDelete) {
    otherProps = { ...other };
  } else {
    otherProps = { onDelete: (e) => onDelete(e, text), ...other };
  }

  const txtstr = `${text}`;

  return (
    <MuiChip
      label={txtstr ? `${txtstr.substring(0, characterLimit)}${txtstr.length > characterLimit ? "..." : ""}` : "..."}
      classes={{ label: classes.label }}
      className={classnames(classes.chip, className)}
      tabIndex={-1}
      {...otherProps}
    />
  );
}

Chip.propTypes = {
  /** Custom styling object */
  className: PropTypes.string,
  /** Text that will display as the chip's label */
  text: PropTypes.string.isRequired,
  /** Boolean that prevents onDelete from being included since onDelete will automatically create a delete icon */
  cannotDelete: PropTypes.bool,
  /** Callback that deletes chip (no delete icon if onDelete is not provided) */
  onDelete: PropTypes.func,
  /** Characters beyond the limit will be replaced with an ellipsis */
  characterLimit: PropTypes.number,
};

export default Chip;



// WEBPACK FOOTER //
// ./src/components/Chip.jsx